(function () {
  'use strict';

  angular
      .module('tfc.Files')
      .controller('FileTreeCtrl', FileTreeCtrl);

  // @ngInject
  function FileTreeCtrl($rootScope, $interpolate, $state, $scope, retailers, Reports, tlaTree) {
    var vm = this;
    vm.retailers = _.keyBy(retailers, 'tla');
    vm.params = _.cloneDeep($state.params);

    function getTreeStructure(dataObject) {
      var tree = [];
      dataObject.name = vm.retailers[dataObject.tla].name;
      tree.push(dataObject);
      tree = _.toArray(
        _.mapValues(tree, function(retailerGroup) {
          if(retailerGroup.tla == vm.params.tla) {
            vm.toggleOpen(retailerGroup);
            if(vm.params.year) {
              retailerGroup.years = _.map(retailerGroup.years, function (yearGroup) {
                if(yearGroup.year == vm.params.year) {
                  yearGroup.isSelected = true;
                }
                return yearGroup;
              });
            }
          }
          return retailerGroup;
        })
      );
      return tree;
    }

    vm.toggleOpen = function (group) {
      group.isSelected = !group.isSelected;
      if(group.years && group.years.length == 1) {
        vm.toggleOpen(group.years[0]);
      }
    };

    vm.goTo = function (tla, year, category) {
      $state.go('files', {tla: tla, year: year, category: category});
    };

    vm.goToUpload = function (file, tla, year, category) {
      $state.go('upload', {tla: tla, year: year, category: category}).then(function () {
        var $off = $scope.$on('uploadFormLoaded', function () {
          $off();
          $rootScope.$broadcast('dragndropfile', file);
        });
      });
    };

    vm.open = function (isDragging, group) {
      group.isSelected = true;
    };

    vm.activeRetailerList = function(){
      $rootScope.fileStructure = retailers.filter(function(store) {
        return store.status !== "X";
      });
    };

    vm.getActiveRetailerList = function(){
      if(tlaTree){
        $rootScope.fileStructure = getTreeStructure(tlaTree);
      }else{
        vm.activeRetailerList();
      }
    }

    vm.getActiveRetailerList();
  }



})();